import ReportCustomImage from './reportCustomImage'
export default ReportCustomImage
